<template>
<div class="chapter">
<div class="inner_page">
<p class="fmh" id="toc"><span class="epub-b">Contents</span></p>
<p class="toc"><span href="#/xhtml/title#tit" title="Link target outside of Sample">Title Page</span></p>
<p class="toc"><span href="#/xhtml/copyrightnotice#notice" title="Link target outside of Sample">Copyright Notice</span></p>
<p class="toc"><a href="#/xhtml/dedication#ded">Dedication</a></p>
<p class="toc-bot"><a href="#/xhtml/trans#tran">Translator’s Note</a></p>
<p class="toc-bot"><a href="#/xhtml/prologue#pro">Prologue</a></p>
<p class="toc"><a href="#/xhtml/part1#pt1"><span class="epub-b">Part 1: The Man Who Loved Horses</span></a></p>
<p class="toc"><a href="#/xhtml/chapter1#ch1">Chapter 1</a></p>
<p class="toc"><a href="#/xhtml/chapter2#ch2">Chapter 2</a></p>
<p class="toc"><a href="#/xhtml/chapter3#ch3">Chapter 3</a></p>
<p class="toc"><a href="#/xhtml/chapter4#ch4">Chapter 4</a></p>
<p class="toc"><span href="#/xhtml/chapter5#ch5" title="Link target outside of Sample">Chapter 5</span></p>
<p class="toc"><span href="#/xhtml/chapter6#ch6" title="Link target outside of Sample">Chapter 6</span></p>
<p class="toc"><span href="#/xhtml/chapter7#ch7" title="Link target outside of Sample">Chapter 7</span></p>
<p class="toc"><span href="#/xhtml/chapter8#ch8" title="Link target outside of Sample">Chapter 8</span></p>
<p class="toc-bot"><span href="#/xhtml/chapter9#ch9" title="Link target outside of Sample">Chapter 9</span></p>
<p class="toc"><span href="#/xhtml/part2#pt2" title="Link target outside of Sample"><span class="epub-b">Part 2: Welcome to Hell</span></span></p>
<p class="toc"><span href="#/xhtml/chapter10#ch10" title="Link target outside of Sample">Chapter 10</span></p>
<p class="toc"><span href="#/xhtml/chapter11#ch11" title="Link target outside of Sample">Chapter 11</span></p>
<p class="toc"><span href="#/xhtml/chapter12#ch12" title="Link target outside of Sample">Chapter 12</span></p>
<p class="toc"><span href="#/xhtml/chapter13#ch13" title="Link target outside of Sample">Chapter 13</span></p>
<p class="toc"><span href="#/xhtml/chapter14#ch14" title="Link target outside of Sample">Chapter 14</span></p>
<p class="toc"><span href="#/xhtml/chapter15#ch15" title="Link target outside of Sample">Chapter 15</span></p>
<p class="toc"><span href="#/xhtml/chapter16#ch16" title="Link target outside of Sample">Chapter 16</span></p>
<p class="toc"><span href="#/xhtml/chapter17#ch17" title="Link target outside of Sample">Chapter 17</span></p>
<p class="toc"><span href="#/xhtml/chapter18#ch18" title="Link target outside of Sample">Chapter 18</span></p>
<p class="toc"><span href="#/xhtml/chapter19#ch19" title="Link target outside of Sample">Chapter 19</span></p>
<p class="toc"><span href="#/xhtml/chapter20#ch20" title="Link target outside of Sample">Chapter 20</span></p>
<p class="toc"><span href="#/xhtml/chapter21#ch21" title="Link target outside of Sample">Chapter 21</span></p>
<p class="toc-bot"><span href="#/xhtml/chapter22#ch22" title="Link target outside of Sample">Chapter 22</span></p>
<p class="toc"><span href="#/xhtml/part3#pt3" title="Link target outside of Sample"><span class="epub-b">Part 3: White</span></span></p>
<p class="toc"><span href="#/xhtml/chapter23#ch23" title="Link target outside of Sample">Chapter 23</span></p>
<p class="toc"><span href="#/xhtml/chapter24#ch24" title="Link target outside of Sample">Chapter 24</span></p>
<p class="toc"><span href="#/xhtml/chapter25#ch25" title="Link target outside of Sample">Chapter 25</span></p>
<p class="toc"><span href="#/xhtml/chapter26#ch26" title="Link target outside of Sample">Chapter 26</span></p>
<p class="toc"><span href="#/xhtml/chapter27#ch27" title="Link target outside of Sample">Chapter 27</span></p>
<p class="toc-bot"><span href="#/xhtml/epilogue#epi" title="Link target outside of Sample">Epilogue</span></p>
<p class="toc"><span href="#/xhtml/authorsnote#an" title="Link target outside of Sample">Author’s Note</span></p>
<p class="toc"><span href="#/xhtml/ack#ack" title="Link target outside of Sample">Acknowledgements</span></p>
<p class="toc"><span href="#/xhtml/copyright#crt" title="Link target outside of Sample">Copyright</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?6bf2f348